import {Model} from "ords/dist/model/model";

export class RubricableSkillLevelYear extends Model {

}

export const RubricableSkillLevelYearModelConfig = {
    name: 'rubricable_skill_level_years',
    model: RubricableSkillLevelYear,
    relations : [
        {name: 'school_education_level_skill_trees', model_name: 'school_education_level_skill_trees', type: 'hasOne'},
    ]
}
